(() => {
  if (window.bedderHelixNavigation) return;
  window.bedderHelixNavigation = true;
  const cache = new Map();
  const models = ['sunset','moonlight','midnight','dusk','twilight','dawn','plus'];
  const normalize = value => {
    let s = String(value || '').toLowerCase().replace(/[”"’]/g,'').replace(/\s+/g,' ').trim();
    if (/head.?split|split.?head/.test(s)) return s;
    if (/rv|short|olympic|bunk/.test(s)) return s;
    if (/split.*(cal|california)/.test(s)) return 'split cal king';
    if (/split.*king/.test(s)) return 'split king';
    if (/^(ca|cal|california) king$/.test(s)) return 'cal king';
    return s;
  };
  function selected(root) {
    const main = document.querySelector('product-info[id^="MainProduct-"]');
    const data = main?.querySelector('variant-selects [data-selected-variant]');
    let variant = JSON.parse(root.dataset.hxInitial);
    if (data?.textContent) { try { variant = JSON.parse(data.textContent) || variant; } catch (_) {} }
    const options = JSON.parse(root.dataset.hxOptions);
    const sizeIndex = options.findIndex(x => /size/i.test(x));
    const size = variant?.options?.[sizeIndex] || '';
    let model = root.dataset.hxModel;
    if (root.dataset.hxSystem === 'true') model = models.find(m => variant?.options?.some(x => x.toLowerCase().replace('midnigth','midnight').startsWith(m))) || '';
    return {size,model,variant};
  }
  function supportLabel(text, handle) {
    const family = handle?.split('-')[1];
    if (!['core','luxe'].includes(family)) return text;
    return String(text).replace(/\b(?:Core|Luxe) Support\b/g, family === 'core' ? 'Core Support' : 'Luxe Support');
  }
  function refresh() {
    document.querySelectorAll('[data-hx-navigation]').forEach(root => {
      const state = selected(root);
      document.querySelectorAll('product-info[id^="MainProduct-"] variant-selects label, product-info[id^="MainProduct-"] variant-selects option').forEach(label => {
        Array.from(label.childNodes).filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => {
          const corrected = supportLabel(node.textContent, root.dataset.hxHandle);
          if (node.textContent !== corrected) node.textContent = corrected;
        });
      });
      const current = root.querySelector('[data-hx-current]');
      const text = [state.model ? state.model[0].toUpperCase()+state.model.slice(1) : '',state.size].filter(Boolean).join(' · ');
      if(current && current.textContent !== text) current.textContent = text;
      refreshAccessories(state);
    });
  }

  function refreshAccessories(state) {
    document.querySelectorAll('[data-hx-complete]').forEach(section => {
      if (!section.dataset.chosenKit) {
        const cooling=state.variant?.options?.some(o=>/glacio|coolforce/i.test(o));
        section.querySelectorAll('[data-hx-kit-panel]').forEach(p=>p.hidden=p.dataset.hxKitPanel !== (cooling?'cooling':'everyday'));
        section.querySelectorAll('[data-hx-kit]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.hxKit===(cooling?'cooling':'everyday'))));
      }
      section.querySelectorAll('[data-hx-accessory]').forEach(card => {
        const variants=JSON.parse(card.dataset.hxVariants), options=JSON.parse(card.dataset.hxOptions);
        const link=card.querySelector('[data-hx-accessory-link]'),note=card.querySelector('[data-hx-accessory-note]'),price=card.querySelector('[data-hx-accessory-price]');
        const set=(el,t)=>{if(el.textContent!==t)el.textContent=t;};
        if(card.dataset.hxPillow==='true') {set(note,'Choose your pillow size');return;}
        const i=options.findIndex(o=>/size/i.test(o));
        if(!state.size || i<0)return;
        const matches=variants.filter(v=>normalize(v.options[i])===normalize(state.size));
        const chosen=matches.find(v=>v.available)||matches[0];
        if(!chosen) {
          link.href=card.dataset.hxUrl;link.removeAttribute('aria-disabled');
          set(link,'Check available sizes →');set(note,state.size+' match not available');set(price,'');return;
        }
        const other=chosen.options.filter((v,j)=>j!==i).join(' · ');
        set(note,state.size+(other?' · '+other:'')+(chosen.available?'':' · Sold out'));
        if(chosen.price<=0) {
          link.removeAttribute('href');link.setAttribute('aria-disabled','true');
          set(price,section.dataset.hxCopy);set(link,'Coming soon');return;
        }
        link.href=card.dataset.hxUrl+'&variant='+chosen.id;
        link.removeAttribute('aria-disabled');
        set(price,new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:section.dataset.hxCurrency||'USD'}).format(chosen.price/100));
        set(link,chosen.available?'View options →':'View availability →');
      });
    });
  }
  document.addEventListener('click',event=>{
    const b=event.target.closest('[data-hx-kit]');if(!b)return;
    const section=b.closest('[data-hx-complete]');section.dataset.chosenKit=b.dataset.hxKit;
    section.querySelectorAll('[data-hx-kit]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));
    section.querySelectorAll('[data-hx-kit-panel]').forEach(x=>x.hidden=x.dataset.hxKitPanel!==b.dataset.hxKit);
  });

  async function navigate(root,handle) {
    const message = (handle.includes('smart-bed-bundle') && document.querySelector('[data-hx-system-message]')) || root.querySelector('[data-hx-message]');
    message.hidden = false;
    message.textContent = 'Checking the matching model and size…';
    try {
      if (!cache.has(handle)) cache.set(handle,fetch('/products/'+handle+'.js').then(r => {if(!r.ok) throw Error();return r.json();}));
      const target = await cache.get(handle);
      const source = selected(root);
      const sizeIndex = target.options.findIndex(x => /size/i.test(typeof x === 'string' ? x : x.name));
      const isSystem = handle.includes('smart-bed-bundle');
      const matches = target.variants.filter(v => normalize(v.options[sizeIndex]) === normalize(source.size) && (!isSystem || v.options.some(o => o.toLowerCase().replace('midnigth','midnight').startsWith(source.model))));
      const exact = matches.filter(v => v.available);
      if (!exact.length) {
        message.replaceChildren(document.createTextNode((matches.length ? 'This matching configuration is currently unavailable. ' : 'No exact model and size match is listed. ')+'Your selection has not been changed. '));
        const a=document.createElement('a');a.href='/products/'+handle+'?view=helix-review';a.textContent='View other options and choose a size';message.append(a);
        return;
      }
      const sourceOptions = source.variant.options.filter(o => normalize(o)!==normalize(source.size));
      exact.sort((a,b) => b.options.filter(x=>sourceOptions.includes(x)).length-a.options.filter(x=>sourceOptions.includes(x)).length);
      const chosen=exact[0];
      const url='/products/'+handle+'?view=helix-review&variant='+chosen.id;
      const comparable = value => String(value).toLowerCase().replace(/\\b(core|luxe) support\\b/g,'standard support');
      const targetNames = target.options.map(o => typeof o === 'string' ? o : o.name);
      const sourceNames = JSON.parse(root.dataset.hxOptions);
      const changed = [];
      targetNames.forEach((name,i) => {
        if (/size/i.test(name)) return;
        const j = sourceNames.findIndex(n => n.toLowerCase() === name.toLowerCase());
        if (j >= 0 && comparable(source.variant.options[j]) !== comparable(chosen.options[i])) changed.push(chosen.options[i]);
      });
      if (!isSystem && !changed.length) { location.assign(url); return; }
      message.replaceChildren(document.createTextNode(isSystem ? source.size + ' selected. Choose your base and bedding. ' : 'This option uses '+changed.map(v=>supportLabel(v,handle)).join(', ')+'. '));
      const a=document.createElement('a');a.href=url;a.textContent=isSystem?'Build your sleep system →':'View '+target.title+' →';message.append(a);
      a.focus();
    } catch (_) {
      message.textContent='We could not verify a matching configuration. Please try again or ask Bedder Mattress for fit assistance.';
    }
  }
  document.addEventListener('click',event => {
    const link=event.target.closest('[data-hx-family-link],[data-hx-system-link],[data-hx-bundle-family],[data-hx-fit]');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey) return;
    const root=link.closest('[data-hx-navigation]') || document.querySelector('[data-hx-navigation]');if(!root)return;
    if(link.dataset.hxFit === 'helix-dream-pillow-set') return;
    if(link.dataset.hxFit) {event.preventDefault();navigate(root,link.dataset.hxFit);return;}
    const state=selected(root);
    if(!models.includes(state.model)||!['core','luxe','elite'].includes(root.dataset.hxFamily))return;
    event.preventDefault();
    const family=link.dataset.hxFamilyLink || link.dataset.hxBundleFamily || root.dataset.hxFamily;
    navigate(root,'helix-'+family+'-'+((link.hasAttribute('data-hx-system-link') || link.hasAttribute('data-hx-bundle-family'))?'smart-bed-bundle':state.model+'-mattress'));
  });
  document.addEventListener('change',event => {
    if(event.target.matches('[data-hx-collection-model]') && event.target.value) {location.assign(event.target.value);return;}
    if(event.target.matches('[data-hx-model-select]')) {
      const root=event.target.closest('[data-hx-navigation]');
      navigate(root,'helix-'+root.dataset.hxFamily+'-'+event.target.value+'-mattress');
    }
    refresh();
  });
  document.addEventListener('shopify:section:load',refresh);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
  const main=document.querySelector('product-info[id^="MainProduct-"]');
  if(main)new MutationObserver(refresh).observe(main,{childList:true,subtree:true});
})();
